import React from 'react'
import { IconTypeProps } from '../icon';

export function IconFile({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      className={className}
      onClick={onClick}
      {...rest}
      viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.425 11.7C9.425 11.7862 9.39076 11.8689 9.32981 11.9298C9.26886 11.9908 9.1862 12.025 9.1 12.025H1.3C1.2138 12.025 1.13114 11.9908 1.07019 11.9298C1.00924 11.8689 0.975 11.7862 0.975 11.7V1.3C0.975 1.2138 1.00924 1.13114 1.07019 1.07019C1.13114 1.00924 1.2138 0.975 1.3 0.975H5.2V3.9C5.2 4.24478 5.33696 4.57544 5.58076 4.81924C5.82456 5.06304 6.15522 5.2 6.5 5.2H9.425V11.7ZM6.175 1.70365L8.6957 4.225H6.5C6.4138 4.225 6.33114 4.19076 6.27019 4.12981C6.20924 4.06886 6.175 3.9862 6.175 3.9V1.70365ZM10.0191 4.1691L6.23025 0.3809C6.21335 0.364 6.19255 0.351 6.175 0.3354C6.13028 0.293196 6.08272 0.254104 6.03265 0.2184C6.00665 0.20085 5.97675 0.18915 5.94945 0.1742C5.9033 0.1482 5.8578 0.1196 5.80905 0.0988C5.67961 0.0471011 5.54262 0.0168054 5.40345 0.00909996C5.3729 0.00714996 5.343 0 5.3118 0H1.3C0.955218 0 0.624558 0.136964 0.380761 0.380761C0.136964 0.624558 0 0.955218 0 1.3V11.7C0 12.0448 0.136964 12.3754 0.380761 12.6192C0.624558 12.863 0.955218 13 1.3 13H9.1C9.44478 13 9.77544 12.863 10.0192 12.6192C10.263 12.3754 10.4 12.0448 10.4 11.7V5.0882C10.3999 4.74345 10.2629 4.41284 10.0191 4.1691Z" />
    </svg>
  );
}
